import React from "react";
import "./Div2.css";

import a from "../../../../asset/Biography/Div2/1.png";
import b from "../../../../asset/Biography/Div2/2.png";
import c from "../../../../asset/Biography/Div2/3.png";

export const Div2 = () => {
  return (
    <>
      <div className="div2">
        <div className="div2-left">
          <div className="div2-left-block">
            <div className="div2-left-block-img-container">
              <img src={a} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
          <div className="div2-left-block">
            <div className="div2-left-block-img-container">
              <img src={b} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
          <div className="div2-left-block">
            <div className="div2-left-block-img-container">
              <img src={c} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
        </div>
        <div className="div2-center">
          <div className="div2-center-line">
            <div className="div2-center-circle1">
              <span>17th March, 2023</span>
            </div>
            <div className="div2-center-circle2">
              <span>17th March, 2023</span>
            </div>
            <div className="div2-center-circle3">
              <span>17th March, 2023</span>
            </div>
            <div className="div2-center-circle4">
              <span>17th March, 2023</span>
            </div>
            <div className="div2-center-circle5">
              <span>17th March, 2023</span>
            </div>
            <div className="div2-center-circle6">
              <span>17th March, 2023</span>
            </div>
          </div>
        </div>
        <div className="div2-right">
          <div className="div2-right-block">
            <div className="div2-right-block-img-container">
              <img src={a} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
          <div className="div2-right-block">
            <div className="div2-right-block-img-container">
              <img src={b} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
          <div className="div2-right-block">
            <div className="div2-right-block-img-container">
              <img src={c} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
        </div>
      </div>

      <div className="div2-mobile">
      <div className="div2-center">
          <div className="div2-center-line">
            <div className="div2-center-circle1">
              <span>17th March, 2023</span>
            </div>
            <div className="div2-center-circle2">
              <span>17th March, 2023</span>
            </div>
            <div className="div2-center-circle3">
              <span>17th March, 2023</span>
            </div>
            <div className="div2-center-circle4">
              <span>17th March, 2023</span>
            </div>
            <div className="div2-center-circle5">
              <span>17th March, 2023</span>
            </div>
            <div className="div2-center-circle6">
              <span>17th March, 2023</span>
            </div>
          </div>
        </div>
        <div className="div2-mobile-right">
        <div className="div2-right-block">
            <div className="div2-right-block-img-container">
              <img src={c} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
          <div className="div2-right-block">
            <div className="div2-right-block-img-container">
              <img src={c} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
          <div className="div2-right-block">
            <div className="div2-right-block-img-container">
              <img src={c} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>

          <div className="div2-right-block">
            <div className="div2-right-block-img-container">
              <img src={c} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>

          <div className="div2-right-block">
            <div className="div2-right-block-img-container">
              <img src={c} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>

          <div className="div2-right-block">
            <div className="div2-right-block-img-container">
              <img src={c} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
